// removed by extract-text-webpack-plugin
module.exports = {"additionalInfo":"Disclaimer__additionalInfo__Zgdyf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Disclaimer/Disclaimer.css
// module id = 564
// module chunks = 0